"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const plugin_1 = require("@/plugin");
const mainData_1 = __importDefault(require("./../mainData"));
exports.default = (0, vue_1.defineComponent)({
    name: 'ExternalVehicle',
    components: {
        ListView: ListView_1.default
    },
    data() {
        return {
            mainData: mainData_1.default,
            listOption: {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                search: {},
                searchMenu: [
                    {
                        prop: 'setSearch',
                        name: '查询',
                        type: 'primary'
                    },
                    {
                        prop: 'resetSearch',
                        name: '重置',
                        type: 'default'
                    }
                ],
                menu: {
                    list: [
                        {
                            prop: 'redemption',
                            name: '赎回',
                            hidden({ record }) {
                                // 逾期状态 = 逾期 && 车辆状态 = 已收车
                                if (record.overStatus.value === '2' && record.vehicleStatus.value === '2') {
                                    return false;
                                }
                                else {
                                    return true;
                                }
                            }
                        },
                        {
                            prop: 'handle',
                            name: '处置',
                            hidden({ record }) {
                                // 逾期状态 = 逾期 && 车辆状态 = 已收车
                                if (record.overStatus.value === '2' && record.vehicleStatus.value === '2') {
                                    return false;
                                }
                                else {
                                    return true;
                                }
                            }
                        }
                    ]
                }
            }
        };
    },
    computed: {
        width() {
            return this.getWidth();
        }
    },
    mounted() {
        this.mainData.$loadData(true);
    },
    beforeUnmount() {
        mainData_1.default.$reset();
    },
    methods: {
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        },
        onMenu(from, act, payload) {
            if (from === 'table') {
                if (act === 'preservation') {
                    this.$router.push(`/external/preservation/info/${payload.record.id}/build`);
                }
                else if (act === 'guarantor') {
                    this.$router.push(`/overdue/guarantor/info/${payload.record.id}/build`);
                }
            }
        }
    }
});
